<script setup>
import { computed } from 'vue'

const emit = defineEmits(['update:checked'])

const props = defineProps({
    checked: {
        type: [Array, Boolean],
        default: false,
    },
    value: {
        type: String,
        default: null,
    },
})

const proxyChecked = computed({
    get() {
        return props.checked
    },

    set(val) {
        emit('update:checked', val)
    },
})
</script>

<template>
    <input
        v-model="proxyChecked"
        type="checkbox"
        :value="value"
        class="rounded border-zinc-300 text-cyan-600 shadow-sm focus:ring-cyan-500 dark:border-zinc-700 dark:bg-zinc-900 dark:focus:ring-cyan-600 dark:focus:ring-offset-zinc-800"
    />
</template>
